<template>
    <!-- 审核-其他 -->
    <vForm class="clearfix" v-model="formData.content.extra_audit_action" ref="dataForm" labelWidth="120" style="text-align: left;">
        <vFormItem prop="radioType" label=" " labelWidth="250" :rules="required">
            <RadioGroup v-model="formData.content.extra_audit_action">
                <Radio :label="1">{{$t('fbb.inbound.pass_audit', { defaultValue: '审核通过' })}}</Radio>
                <Radio :label="2">{{$t('fbb.inbound.back_audit', { defaultValue: '审核拒回' })}}</Radio>
            </RadioGroup>
        </vFormItem>
        <div class="access clearfix" v-if="formData.content.extra_audit_action === 1">
            <Row>
                <vCol span="11">
                    <vFormItem :label="$t('fbb.headlogistics.logistics_type', { defaultValue: '发运类型' })" class="width-100per" prop="logisticsType" :rules="required">
                        <vSelect v-model="formData.content.logistics_type">
                            <vOption v-for="item in logisticsTypeList" :key="item.key" :value="item.value">{{item.label}}
                            </vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
                <vCol span="11" v-if="formData.content.logistics_type === 'transfer'">
                    <vFormItem :label="$t('fbb.headlogistics.forwarder_warehouse', { defaultValue: '中转仓' })" class="width-100per" prop="forwarder_warehouse_id">
                        <vSelect v-model="formData.content.forwarder_warehouse_id" filterable @on-change="getWarehouseName">
                            <vOption v-for="item in getFilterDisabledWarehouse" :key="item.key" :value="item.value">{{item.label}}
                            </vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
            </Row>
            <Row>
                <vCol span="11">
                    <vFormItem :label="$t('fbb.headlogistics.actual_loading_date', { defaultValue: '实际装柜日期' })" class="width-100per" prop="actual_loading_date" :rules="required">
                        <vDatepicker v-model="formData.content.actual_loading_date" type="date"></vDatepicker>
                    </vFormItem>
                </vCol>
                <vCol span="11">
                    <vFormItem :label="$t('fbb.headlogistics.actual_sail_at', { defaultValue: '实际开船日期' })" class="width-100per" prop="extra_realsail_date" :rules="required">
                        <vDatepicker v-model="formData.content.extra_realsail_date" type="date"></vDatepicker>
                    </vFormItem>
                </vCol>
            </Row>
            <Row>
                <vCol span="11">
                    <vFormItem :label="$t('fbb.headlogistics.expect_port_arrival_date', { defaultValue: '预计到港日期' })" class="width-100per" prop="extra_expectarrive_date" :rules="required">
                        <vDatepicker v-model="formData.content.extra_expectarrive_date" type="date"></vDatepicker>
                    </vFormItem>
                </vCol>
                <vCol span="11">
                    <vFormItem :label="$t('fbb.headlogistics.expect_warehouse_arrval_date', { defaultValue: '预计到仓日期' })" class="width-100per" prop="expect_stockin_at" :rules="required">
                        <vDatepicker v-model="formData.content.expect_stockin_at" type="date"></vDatepicker>
                    </vFormItem>
                </vCol>
            </Row>
            <Row>
                <vCol span="11">
                    <vFormItem :label="`${$t('fbb.headlogistics.logistics_number_logistics', { defaultValue: '物流单号' })}/${$t('fbb.headlogistics.logistics_number', { defaultValue: '提单号' })}`" class="width-100per" prop="inSupplier" :rules="required">
                        <vInput v-model="order"></vInput>
                    </vFormItem>
                </vCol>
                <vCol span="11">
                    <vFormItem :label="$t('fbb.headlogistics.transport_type', { defaultValue: '发运方式' })" class="width-100per" prop="transport_type" :rules="required">
                        <vSelect v-model="formData.content.transport_type">
                            <vOption v-for="item in transportList" :key="item.key" :value="item.value">{{item.label}}</vOption>
                        </vSelect>
                    </vFormItem>
                </vCol>
            </Row>
            <Row>
                <vCol span="11">
                    <vFormItem label="Bound" prop="bound" :rules="required">
                        <vInput v-model="formData.content.bound"></vInput>
                    </vFormItem>
                </vCol>
            </Row>
            <div v-if="formData.content.transport_type === 0">
                <div v-for="item in formData.content.inbounds" :key="item.key">
                    <vCol span="24">
                        <div class="font-weight" style="padding-left: 20px; height: 42px;">{{$t('fbb.headlogistics.inbound', { defaultValue: '入库单' })}} {{item.id}}</div>
                    </vCol>
                    <vCol span="11">
                        <vFormItem :label="$t('fbb.headlogistics.20gp_number', { defaultValue: '20GP数量' })" labelWidth="100">
                            <vInputNumber min="0" v-model="item.data['extra_cabinet_20GP_qty']"></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="11">
                        <vFormItem :label="$t('fbb.headlogistics.20gp_container_number', { defaultValue: '20GP集装箱号' })">
                            <vInput :placeholder="$t('fbb.headlogistics.container_tips', { defaultValue: '多个集装箱号用,分隔' })" v-model="item.data['extra_cabinet_20GP_no']"></vInput>
                        </vFormItem>
                    </vCol>
                    <vCol span="11">
                        <vFormItem :label="$t('fbb.headlogistics.40gp_number', { defaultValue: '40GP数量' })" labelWidth="100">
                            <vInputNumber min="0" v-model="item.data['extra_cabinet_40GP_qty']"></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="11">
                        <vFormItem :label="$t('fbb.headlogistics.40gp_container_number', { defaultValue: '40GP集装箱号' })">
                            <vInput :placeholder="$t('fbb.headlogistics.container_tips', { defaultValue: '多个集装箱号用,分隔' })" v-model="item.data['extra_cabinet_40GP_no']"></vInput>
                        </vFormItem>
                    </vCol>
                    <vCol span="11">
                        <vFormItem :label="$t('fbb.headlogistics.40hq_number', { defaultValue: '40HQ数量' })" labelWidth="100">
                            <vInputNumber min="0" v-model="item.data['extra_cabinet_40HQ_qty']"></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="11">
                        <vFormItem :label="$t('fbb.headlogistics.40hq_container_number', { defaultValue: '40HQ集装箱号' })">
                            <vInput :placeholder="$t('fbb.headlogistics.container_tips', { defaultValue: '多个集装箱号用,分隔' })" v-model="item.data['extra_cabinet_40HQ_no']"></vInput>
                        </vFormItem>
                    </vCol>
                    <vCol span="11">
                        <vFormItem :label="$t('fbb.headlogistics.45hq_number', { defaultValue: '45HQ数量' })" labelWidth="100">
                            <vInputNumber min="0" v-model="item.data['extra_cabinet_45HQ_qty']"></vInputNumber>
                        </vFormItem>
                    </vCol>
                    <vCol span="11">
                        <vFormItem :label="$t('fbb.headlogistics.45hq_container_number', { defaultValue: '45HQ集装箱号' })">
                            <vInput :placeholder="$t('fbb.headlogistics.container_tips', { defaultValue: '多个集装箱号用,分隔' })" v-model="item.data['extra_cabinet_45HQ_no']"></vInput>
                        </vFormItem>
                    </vCol>
                </div>
            </div>
            <div v-else>
                <Row>
                    <vCol span="11">
                        <vFormItem :label="$t('fbb.headlogistics.total_volumn', { defaultValue: '总体积' })" prop="total_vol" :rules="required">
                            <vInputNumber min="0" v-model="formData.content.total_vol"></vInputNumber>
                        </vFormItem>
                    </vCol>
                </Row>
            </div>
            <vCol span="11">
                <vFormItem :label="$t('global.common.notes', { defaultValue: '备注' })" labelWidth="120" class="width-100per">
                    <vTextarea></vTextarea>
                </vFormItem>
            </vCol>
            <vCol span="11">
                <vFormItem :label="$t('fbb.headlogistics.attach_upload', { defaultValue: '附件上传' })" class="width-100per">
                    <div class="upload">
                        <div class="upload-item" v-for="(item, index) in formData.attachments" :key="item.key">
                            <div class="filename">{{item.fileName}}</div>
                            <div><Icon class="close" size="13" type="md-close" @click="clearUpload(index)" /></div>
                        </div>
                    </div>
                    <vButton theme="success" @click="importFile">{{$t('global.common.add', { defaultValue: '添加' })}}</vButton>
                </vFormItem>
            </vCol>
        </div>
        <div class="refuse" v-else>
            <Row>
                <vCol span="11" offset="4">
                    <vFormItem :label="$t('global.common.notes', { defaultValue: '备注' })" class="width-100per">
                        <vTextarea v-model="formData.remark"></vTextarea>
                    </vFormItem>
                </vCol>
            </Row>
        </div>
        <vModal
            class="hidefooter customerupload"
            v-model="operate.show"
            :title="operate.title"
            v-bind="operate"
        >
            <compUpload
                v-bind="getFileProps"
                @on-success="aaasuccess"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
        <div class="pull-right">
            <vButton style="margin: 10px 5px;" theme="primary" :disabled="isSubmit" @click="submit">{{$t('global.common.confirm', { defaultValue: '确定' })}}</vButton>
            <vButton style="margin: 10px 5px;" @click="cancel">{{$t('global.common.operate_cancel', { defaultValue: '取消' })}}</vButton>
        </div>
    </vForm>
</template>
<script>
    import { mapGetters } from 'vuex'
    import mixinList from '../mixin'
    import { HttpUpdateLogistics } from "@/service/headlogistics"
    export default {
        props: ["componentName", "originData", "type"],
        mixins: [mixinList],
        components: {
            compUpload: () => import("@components/templates/upload")
        },
        data() {
            return {
                storageList: [],
                formData: {
                    headId: this.originData.id,
                    isSub: false,
                    type: 43,
                    content: {
                        extra_logistics_no: this.originData.id,
                        extra_audit_action: 1,
                        transport_type: 0,
                        inbounds: []
                    },
                    attachments: []
                },
                required: [{
                    required: true,
                    message: this.$t('global.common.information_empty', { defaultValue: "该信息不能为空,请填写" })
                }],
                operate: {
                    show: false,
                    title: this.$t('fbb.headlogistics.attach_upload', { defaultValue: "附件上传" }),
                    data: {}
                },
                isSubmit: false
            };
        },
        created() {
            this.getChildOrder()
        },
        computed: {
            ...mapGetters('dictionary', ['getFilterDisabledWarehouse']),
            getFileProps() {
                return {
                    action: process.env.VUE_APP_APIURL_UC + '/api/v1/BizAttach/uploadFile',
                    name: "multipartFile",
                    data: {
                        srcLabel: this.originData.id,
                        model: 'logistics',
                        type: 'other',
                    }
                }
            },
        },
        methods: {
            getWarehouseName () {
                let warehouseItem = this.getFilterDisabledWarehouse.filter(item => {
                    return item.value === this.formData.content.forwarder_warehouse_id
                })[0]
                this.formData.content.forwarder_warehouse_code = warehouseItem.attach.code
                this.formData.content.forwarder_warehouse_name = warehouseItem.label
            },
            getChildOrder() {
                this.formData.content.inbounds = this.originData.subLogisticsHeadParams.map(item => {
                    return {
                        id: item.orderNo,
                        data: {}
                    }
                })
            },
            importFile() {
                this.operate.show = true
            },
            aaasuccess(res) {
                this.formData.attachments.push({
                    fileName: res.data.entity.filename,
                    fileUrl: res.data.genUrl
                })
                this.cancelUpload();
            },
            clearUpload (index) {
                this.formData.attachments.splice(index, 1)
            },
            cancelUpload() {
                this.operate.show = false;
            },
            success() {
                this.$emit('on-success')
                this.$emit("on-close")
            },
            cancel() {
                this.$emit("on-close");
            },
            checkLogistics () {
                let flag = true
                // 直达
                if (this.formData.content.logisticsType === 'through') {
                    let testArr = []
                    this.originData.subLogisticsHeadParams.map(item => {
                        testArr.push(item.warehouseCode)
                    })
                    if (new Set(testArr).size > 1) {
                        flag = false
                    }
                }
                return flag
            },
            async submit() {
                if (this.isSubmit) return
                let flag = true
                await this.$refs.dataForm.validate(valid => {
                    if (!valid) {
                        this.$VMessage.error(this.$t('fbb.headlogistics.info_empty', { defaultValue: '必填项不能为空' }))
                        flag = false
                    }
                    if (!this.checkLogistics()) {
                        this.$VMessage.error(this.$t('fbb.headlogistics.error_tip', { defaultValue: '直达单据目的仓必须一致！' }))
                        flag = false
                    }
                    // 集装箱号验证
                    if (this.formData.content.transport_type === 0 && this.formData.content.extra_audit_action === 1) {
                        if (!this.validInbounds(this.formData.content.inbounds)) {
                            flag = false
                        }
                    }
                })
                if (!flag) {
                    return
                }
                // 拒回时不传其他数据
                if (this.formData.content.extra_audit_action === 2) {
                    if (!this.formData.content.remark) {
                        this.formData.content = {}
                    }
                    else {
                        this.formData.content = {
                            remark: this.formData.content.remark
                        }
                    }
                    this.formData.type = 50
                }
                this.isSubmit = true
                await HttpUpdateLogistics(this.formData).then(res => {
                    this.$VMessage.success(res.message)
                    this.success()
                }, err => {
                    this.$VMessage.error(err.message)
                })
                this.isSubmit = false

            }
        }
    };

</script>

<style lang="scss" scoped>
.upload-item {
    display: flex;
    color: #3399ff;

    .filename {
        width: 100%;
        overflow:hidden;
        white-space:nowrap;
        text-overflow: ellipsis;
    }

    .close {
        margin-left: 5px;
        &:hover {
            color: red;
            cursor: pointer;
        }
    }
}
</style>
